import React from 'react'
import ReactDOM from 'react-dom'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import { rgba } from 'polished'
import Link from 'gatsby-link'
import ReactPlayer from 'react-player'

import { Carousel, CarouselModal, VideoPlayer } from '../../../components'

import { media } from '../../../styles/utils'
import { container, bgIcon, padding, hoverState, bgImage, remUnit, remUnitTablet } from '../../../styles/global'
import { ribbon } from '../../../styles/colors';
import { caption, heading2, paragraph } from '../../../styles/type';
import { getActiveSlide, parentHasClass, transitionElement, resetAnimation } from '../utils'

class BlockCarousel extends React.Component {

	constructor(props) {
		super(props);
		this.slider = React.createRef();
	}

	state = {
		sliderID: Math.floor(1000 + Math.random() * 9000),
		modalVisible: false,
		activeSlide: 1,
		activeSlideAfter: 1,
		transitionComplete: false,
		isDragging: false,
	}

	onSlideChange = (index) => {
		this.setState({
			activeSlide: index
		})
	}

	onSlideChangeAfter = (index) => {
		this.setState({
			activeSlideAfter: index
		})
	}

	updateActiveSlide = (activeSlide) => {
		this.slider.current.slider.current.slickGoTo(activeSlide, true)

		this.setState({
			activeSlide: activeSlide
		})
	}

	toggleModal = () => {
		this.setState({
			modalVisible: false
		})
	}

	toggleModalForSlide = (i, inModal, caption_type) => {
		const { activeSlide, modalVisible } = this.state;

		if (!inModal && caption_type == 'short' && i == (activeSlide - 1) && !this.state.isDragging) {
			this.setState({modalVisible: !modalVisible})	
		}	
	}

    onClick = (type) => {
        if (type == 'right') {
            this.slider.current.slider.current.slickNext()
        }

        if (type == 'left') {
            this.slider.current.slider.current.slickPrev()
        }
	}

	renderCaption = (slide, inModal, slideIndex) => {
		const { activeSlide } = this.state;
		const { caption_type } = this.props;

		return (
			<CaptionWrapper
				type={caption_type}
				inModal={inModal}
				visible={inModal ? true : (activeSlide - 1) == slideIndex}
			>
				{slide.use_caption && (
					<React.Fragment>
						{slide.caption_heading && (
							<CaptionHeading>{slide.caption_heading}</CaptionHeading>
						)}

						<Caption
							dangerouslySetInnerHTML={{__html: slide.caption}}  
						/>
					</React.Fragment>
				)}
			</CaptionWrapper>
		)
	}

	checkIfDragging = () => {
		if (this.state.mouseDown) {
			this.setState({ isDragging: true });
			return;
		}
	
		this.setState({ isDragging: false });
	}

	getSlides = (inModal) => {
		const { slides, caption_type } = this.props;
		const { modalVisible, sliderID, activeSlide } = this.state;

		return slides.map((slide, i) => {
			return (
				<Slide
					inModal={inModal}
					slideIndex={i+1}
					activeSlide={activeSlide}
				>
					{!inModal && slide.media_type == 'image' && (
						<Image
							inModal={inModal}
							captionType={caption_type}
							src={slide.image && slide.image.sizes && slide.image.sizes.full_width}
							onClick={() => this.toggleModalForSlide(i, inModal, caption_type)}
						/>
					)}

					{inModal && slide.media_type == 'image' && (
						<ModalImage
							captionType={caption_type}
							image={slide.image && slide.image.sizes && slide.image.sizes.full_width}
						/>
					)}

					{slide.media_type == 'video' && (
                        <VideoPlayer 
                            data={slide}
                        />
					)}

					{this.renderCaption(slide, inModal, i)}
				</Slide>
			)
		})
	}
	
	render() {
		const { data, use_caption, caption, caption_type } = this.props;
		const { modalVisible, activeSlide, activeSlideAfter, transitionComplete } = this.state;
		const isShortCaption = caption_type == 'short' ? true : false;
        
		return (
			<Wrapper
				onMouseDown={() => this.setState({ mouseDown: true })}
				onMouseUp={() => {
					setTimeout(() => {
						this.setState({ mouseDown: false, isDragging: false });
					}, 0);
				}}
				onMouseMove={this.checkIfDragging}
			>
				<Carousel
					slides={this.getSlides()}
					ref={this.slider}
					styles={carouselStyles}
					afterChange={this.onSlideChangeAfter}
					beforeChange={this.onSlideChange}
					settings={{
						speed: 299,
						infinite: true,
						centerMode: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: true,
						focusOnSelect: true,
						dragging: true,
					}}
				/>

				<CarouselModal
					slides={this.getSlides(true)}
					transitionComplete={transitionComplete}
					active={modalVisible}
					activeSlide={activeSlideAfter}
					toggle={this.toggleModal}
					updateActiveSlide={this.updateActiveSlide}
				/>

			</Wrapper>
		)
	}
}

const Wrapper = styled.div`
	position: relative;
`

const Container = styled.div`
	${container}
	display: flex;
	flex-direction: column;
`
	

BlockCarousel.wrapper = css`
	/* override global block style */
	margin-bottom: 10rem !important;

	${media.laptop`
		margin-bottom: 15rem !important;
	`}
`

// Slider

const carouselStyles = css`
	position: relative;
`

const Slide = styled.div`
	.caption-wrapper {
		opacity: 0;
		transition: 0.3s opacity ease;
	}

	${props => {
		if (props.slideIndex == props.activeSlide) return css`
			.caption-wrapper {
				opacity: 1;
			}
		`
	}}

	${props => {
		if (props.inModal) return css`
			display: flex;
			justify-content: center;
			align-items: center;

			height: 100vh;
			width: 100vw;
			padding: 120px;
			box-sizing: border-box;

			${media.tablet`
				padding: 100px;
			`}

			${media.phone`
				padding: 0;
			`}
		`
	}}
`

const Image = styled.img`
	margin: 0 20px;
	width: auto;
	height: 100%;
	max-height: 600px;

	${media.laptop`
		max-height: 460px;
		margin: 0 15px;
	`}

	${media.tablet`
		max-height: 400px;
	`}

	${media.phone`
		max-height: 200px;
		max-width: 300px;
		margin: 0 10px;
	`}

	${props => {
		if (props.captionType == 'long') return css`
			${media.phone`
				max-height: 300px;
			`}
		`
	}}
`

const ModalImage = styled.div`
	background-image: url(${props => props.image});
	height: 100%;
	width: 100%;
	${bgIcon}
`

const Video = styled(ReactPlayer)`
	${props => {
		if (!props.inModal) return css`
			max-height: 600px;

			${media.laptop`
				max-height: 460px;
			`}

			${media.tablet`
				max-height: 400px;
			`}

			${media.phone`
				max-height: 200px;
			`}
		`
	}}
`

const ClickDetector = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;

	${media.tablet`
		display: none;
	`}

    ${props => {
        if (props.type == 'right') return css`
            right: 0;
			left: calc(100% - 235px);
            cursor: e-resize;
        `

		if (props.type == 'left') return css`
            left: 0;
			right: calc(100% - 235px);
            cursor: w-resize;
        `
    }}

	${props => {
        if (props.layout == 'long' && props.type == 'right') return css`
            left: calc(100% - 330px);
		`
		
		if (props.layout == 'long' && props.type == 'left') return css`
            right: calc(100% - 330px);
        `
    }}
`   

// Caption

const CaptionHeading = styled.div`
	${heading2};
`

const Caption = styled.div`
	> * {
		${caption}
	}
`

const CaptionWrapper = styled.div`
	display: block;
	text-align: center;
	opacity: 0;
	transition: opacity 0.25s ease;
	min-height: 17px;

	${props => {
		if (!props.inModal) return css`
			max-width: 80%;
			margin: 2.5rem auto 0;
		`
		
		if (props.inModal) return css`
			position: absolute;
			bottom: 55px;
			left: 50%;
			transform: translateX(-50%);

			${media.tablet`
				${Caption} {
					p {
						bottom: 41px;
					}
				}
			`}
		`
	}}

	${props => {
		if (props.type == 'long') return css`
			margin: 0 auto;
			padding-top: 5.5rem;
			max-width: 440px;

			${media.laptop`
				max-width: 340px;
			`}

			${media.tablet`
				max-width: 200px;
			`}

			${media.phone`
				max-width: 200px;
			`}

			${CaptionHeading} {
				margin-bottom: 3rem;
			}

			${Caption} {
				text-align: left;
				${paragraph}
				text-indent: 0!important;
				
			}
		`
	}}

	${props => {
		if (props.visible) return css`
			opacity: 1;
		`
	}}
`



export default BlockCarousel



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockCarousel.js